import angular from 'angular';
import {Run, Module, Boot, Config} from './decorators';
import Home from './home/routing';
import Login from './auth/routing';
import Account from './account/routing';
import Orders from './orders/routing';
import Dispatch from './dispatch/routing';
import Tickets from './tickets/routing';
import FakeScroll from './directives/fake-scroll';
import Customer from './customers/routing';
import InventoryDashboard from './dashboard/inventory/routing';
import TonsDashboard from './dashboard/tons/routing';

import breadcrumbTpl from 'app/common/breadcrumbs.html';

import Admin from './admin/routing';
import InitService from './services/init';
import ReactDemo from './react/routing';

import './defaults';

import 'font-awesome/scss/font-awesome.scss';
import './scss/main.scss';
import './scss/loading_page/main.scss';
import 'tc-angular-chartjs/dist/tc-angular-chartjs.js';

@Boot({element: document, strictDi: true})
@Module({
    name: 'app',
    modules: [
        Home,
        Login,
        Account,
        Orders,
        Dispatch,
        Tickets,
        Customer,
        Admin,
        FakeScroll,
        InitService,
        InventoryDashboard,
        TonsDashboard,
        ReactDemo,
        'tc.chartjs',
    ],
})
@Config(function($compileProvider) {
    "ngInject";
    $compileProvider.debugInfoEnabled(false);
})
@Config(function(uiGmapGoogleMapApiProvider, growlProvider, $urlRouterProvider){
    "ngInject";
    uiGmapGoogleMapApiProvider.configure({
        key: 'AIzaSyA8bR5Wbf6Kvk0ZOWN5J_dVgdQiG_Ol-hY',
        v: '3.23', //defaults to latest 3.X anyhow
        libraries: 'weather,geometry,visualization',
    });
    growlProvider.globalTimeToLive(4 * 1000);
    growlProvider.globalDisableCountDown(true);
    growlProvider.globalDisableIcons(true);
    growlProvider.globalPosition('bottom-right');
    $urlRouterProvider.deferIntercept();
})
@Config(function ($breadcrumbProvider) {
    "ngInject";
    $breadcrumbProvider.setOptions({
        template: breadcrumbTpl,
        includeAbstract: true,
    });

})
@Run(function($q, $rootScope, $urlRouter, InitService){
    "ngInject";
    $rootScope.image = function(name) {
        return `/images/${name}`;
    };
    InitService().then(function(){
        $urlRouter.sync();
        $urlRouter.listen();
    });


})
export default class App {}



// WEBPACK FOOTER //
// ./src/app/app.js